import { render, staticRenderFns } from "./ProgramTextWidget.vue?vue&type=template&id=1e749b0c&scoped=true&lang=pug&"
import script from "./ProgramTextWidget.vue?vue&type=script&lang=js&"
export * from "./ProgramTextWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e749b0c",
  null
  
)

export default component.exports